import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useScreenMaster } from './ScreenMasterContext';
import IstClock from './IstClock';
import './ScreenMaster.css';

export default function ScreenMaster() {
  const { screens, loading, toggle, refresh } = useScreenMaster();
  const [busyId, setBusyId] = useState(null);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  const onToggle = async (screen) => {
    setBusyId(screen.id);
    setError(null);
    setMessage(null);
    try {
      const next = !screen.enabled;
      await toggle(screen.id, next);
      setMessage(
        next
          ? `${screen.label} ENABLED — frontend, APIs and bot resumed.`
          : `${screen.label} DISABLED — frontend hidden, APIs blocked, bot paused.`
      );
    } catch (e) {
      setError(e?.response?.data?.message || e.message || 'Toggle failed');
    } finally {
      setBusyId(null);
    }
  };

  const enabledCount = screens.filter((s) => s.enabled).length;

  return (
    <div className="sm-page">
      <header className="sm-header">
        <div>
          <p className="sm-eyebrow">Bharat Desk</p>
          <h1>Screen Master</h1>
          <p className="sm-sub">
            Enable only the screens you want to run. Disabled screens stop frontend access, APIs, and backend bots.
          </p>
        </div>
        <div className="sm-header-meta">
          <IstClock />
          <button type="button" className="sm-btn" onClick={() => refresh()}>Refresh</button>
          <Link className="sm-btn sm-btn-primary" to="/NormalTrading">Open Normal V1</Link>
        </div>
      </header>

      <div className="sm-summary">
        <strong>{enabledCount}</strong> of {screens.length || 0} screens enabled
        {loading ? <span> · loading…</span> : null}
      </div>

      {error ? <div className="sm-banner sm-banner-err">{error}</div> : null}
      {message ? <div className="sm-banner sm-banner-ok">{message}</div> : null}

      <div className="sm-list">
        {screens.map((screen) => (
          <article key={screen.id} className={`sm-card${screen.enabled ? ' is-on' : ' is-off'}`}>
            <div className="sm-card-main">
              <h2>{screen.label}</h2>
              <p>{screen.description}</p>
              <small>
                Routes: {(screen.routes || []).join(', ')}
              </small>
            </div>
            <label className="sm-toggle">
              <input
                type="checkbox"
                checked={!!screen.enabled}
                disabled={busyId === screen.id}
                onChange={() => onToggle(screen)}
              />
              <span className="sm-toggle-ui" aria-hidden />
              <strong>{screen.enabled ? 'ON' : 'OFF'}</strong>
            </label>
          </article>
        ))}
      </div>

      <footer className="sm-foot">
        Tip: keep <strong>Normal Trading V1</strong> on while focusing. Turn on a second screen only when needed.
        Screen Master itself is always available at this page.
      </footer>
    </div>
  );
}
